import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';
import ShapesOrange from '../../icons/shapes-orange-2.svg';
import ShapesSky from '../../icons/shapes-sky-2.svg';

import Content from './Content';
import ExploreBy from './ExploreBy';

const Customers = () => (
  <StyledSection>
    <Content />
    <StyledShapesSky />
    <StyledShapesOrange />
    <ExploreBy />
  </StyledSection>
);

const StyledSection = styled(Section)`
  padding-top: 110px;
  padding-bottom: 200px;
  position: relative;
`;

const StyledShapesSky = styled(ShapesSky)`
  position: absolute;
  left: 0;
  top: 450px;
  z-index: -1;
`;

const StyledShapesOrange = styled(ShapesOrange)`
  position: absolute;
  right: 0;
  top: 700px;
  z-index: -1;
`;

export default Customers;
